import { useEffect, useState } from "react";

// Preferências de som do usuário neste navegador (menu da conta).
// "volume" mantém a chave antiga para não perder o valor já escolhido.
const KEYS = {
  volume: "volume",
  muted: "soundMuted",
  tickets: "soundTickets",
  chat: "soundChat",
};

const CHANGE_EVENT = "me:sound-preferences";

const read = (key) => {
  try {
    return window.localStorage.getItem(key);
  } catch (err) {
    return null;
  }
};

const write = (key, value) => {
  try {
    window.localStorage.setItem(key, String(value));
  } catch (err) {
    // Navegador sem localStorage (aba anônima bloqueada): vale só nesta sessão.
  }
};

const clampVolume = (value) => {
  const n = parseFloat(value);
  if (Number.isNaN(n)) return 1;
  return Math.min(1, Math.max(0, n));
};

export const readSoundPreferences = () => ({
  volume: clampVolume(read(KEYS.volume) ?? 1),
  muted: read(KEYS.muted) === "true",
  // Ligados por padrão.
  tickets: read(KEYS.tickets) !== "false",
  chat: read(KEYS.chat) !== "false",
});

export const updateSoundPreferences = (patch) => {
  Object.entries(patch).forEach(([name, value]) => {
    if (!KEYS[name]) return;
    write(KEYS[name], name === "volume" ? clampVolume(value) : Boolean(value));
  });
  window.dispatchEvent(new Event(CHANGE_EVENT));
};

// Volume que de fato toca para um tipo de aviso ("tickets" ou "chat").
export const effectiveVolume = (prefs, channel) =>
  prefs.muted || !prefs[channel] ? 0 : prefs.volume;

// Hook que acompanha mudanças feitas no menu (mesma aba) e em outras abas.
export const useSoundPreferences = () => {
  const [prefs, setPrefs] = useState(readSoundPreferences);

  useEffect(() => {
    const sync = () => setPrefs(readSoundPreferences());
    window.addEventListener(CHANGE_EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(CHANGE_EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  return [prefs, updateSoundPreferences];
};
